import { publicIdSchema } from "@rosc/contracts";
import { t } from "i18next";
import type { OfflineRecording, OfflineVisitForm } from "./types";

export interface OfflineAccount {
  uid: string;
  accountPublicId: string;
}
export const offlineAccountKey = (account: OfflineAccount): string =>
  `${account.uid}:${account.accountPublicId}`;

export const hasPublicRecordingIdentity = (row: OfflineRecording): boolean =>
  row.version === 2 &&
  publicIdSchema.safeParse(row.accountPublicId).success &&
  row.account === `${row.uid}:${row.accountPublicId}` &&
  (!row.form || isPublicVisitForm(row.form));

export const isPublicVisitForm = (form: OfflineVisitForm): boolean =>
  !("customTemplateId" in form) &&
  (form.customTemplatePublicId === null ||
    publicIdSchema.safeParse(form.customTemplatePublicId).success);

/** Old numeric ownership is discoverable by its authenticated UID only. */
export const canAccessOfflineRecording = (
  row: OfflineRecording,
  account: OfflineAccount,
): boolean =>
  row.uid === account.uid &&
  (row.account === offlineAccountKey(account) ||
    (row.account.startsWith(`${account.uid}:`) &&
      /^[1-9][0-9]*$/.test(row.account.slice(account.uid.length + 1))));

// Read when shown, so it follows the interface language.
export const offlineIdentityUpgrade = (): string =>
  t("offlineRecording.errors.identityUpgrade");
